import { Form, Row, Col } from "react-bootstrap";
import { useForm, FormProvider } from "react-hook-form";
import { FileUpload, Input, PageWrapper, Select } from "../../components";
import { useTranslation } from "react-i18next";
import { Pages } from '../../shared/enums'
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { createVideo, getVideoDetail, updateVideo } from "../../api/video";
import { RiEdit2Fill, RiAddLargeLine } from "react-icons/ri";
import Button from '../../components/common/Button';

const VideoDetail = ({ }) => {
    const { t } = useTranslation()
    const form = useForm({
        defaultValues: {
            isPublish: true
        }
    })
    const navigate = useNavigate()
    const { id } = useParams()
    const [isEdit, setIsEdit] = useState(false)
    const [btnLoading, setBtnLoading] = useState(false)

    useEffect(() => {
        if (id !== "new") {
            setIsEdit(true)
            getData()
        }
    }, [])

    const getData = async () => {
        const response = await getVideoDetail(id)
        form.reset({ ...response, image: response.path })
    }

    const create = async (data) => {
        setBtnLoading(true)
        const response = await createVideo(data)
        if (response.success) navigate(Pages.Video)
        setBtnLoading(false)
    }

    const update = async (data) => {
        setBtnLoading(true)
        const response = await updateVideo(id, data)
        if (response.success) navigate(Pages.Video)
        setBtnLoading(false)
    }

    return <PageWrapper
        headerProps={{
            title: isEdit ? "EDIT_VIDEO" : "ADD_VIDEO",
            rightElement: <Button
                type="submit"
                variant="primary"
                icon={isEdit ? <RiEdit2Fill /> : <RiAddLargeLine />}
                loading={btnLoading}
                onClick={() => form.handleSubmit(isEdit ? update : create)()}
            >
                {t(isEdit ? "UPDATE" : "CREATE")}
            </Button>
        }}
    >
        <FormProvider {...form}>
            <Form>
                <Input label={t("TITLE")} name={"title"} rules={{ required: t("TITLE_IS_REQUIRED") }} />
                <Input label={t("DESCRIPTION")} rows={3} name={"description"} rules={{ required: t("DESCRIPTION_IS_REQUIRED") }} />
                <Row>
                    <Col>
                        <Select label={t("IS_PUBLISH")} name={"isPublish"} rules={{ required: t("IS_PUBLISH_IS_REQUIRED") }} options={[{ label: t("YES"), value: true }, { label: t("NO"), value: false }]} />
                    </Col>
                    <Col>
                        <Input label={t("SEQUENCE")} type={"number"} name={"sequence"} rules={{ required: t("SEQUENCE_IS_REQUIRED") }} />
                    </Col>
                </Row>
                <FileUpload
                    fileName={form.getValues('fileName')}
                    label={t("VIDEO")}
                    name="image"
                    rules={{ required: t("VIDEO_IS_REQUIRED") }}
                    readOnly={isEdit}
                    accept="video/*"
                />
            </Form>
        </FormProvider>
    </PageWrapper>
}

export default VideoDetail;